<template>
    <Modal 
      :id="'cmp-label-licence-select-asset'" 
      @cancelled="onCancel"
    >
      <template slot="header"> {{$t('select')}} {{ $t('asset') }} </template>
      <template slot="body">
        <div>
          <button
            class="dt-button v1 btn-width"
            @click.stop="addNew('track')"
          >
            {{ $dft.capHead($t('track'))}}
          </button>
          <button
            class="dt-button v1 btn-width"
            @click.stop="addNew('product')"
          >
            {{$dft.capHead($t('product'))}}
          </button>
          <button
            class="dt-button v1 btn-width"
            @click.stop="addNew('release')"
          >
            {{$dft.capHead($t('release'))}}
          </button>
          <button 
            class="dt-button s6"
            style="margin-left: 10px;" 
            @click.stop="onCancel"
          >Cancel
          </button>
        </div>
      </template>
      <template slot="options">
     
        <!-- <button 
          class="dt-button s6" 
          @click.stop="onCancel"
        >Cancel</button> -->
           <!-- <button
          class="dt-button v1 with-ico"
           :class="{ disabled: !isFormValid }"
          :disabled="!isFormValid"
          @click.stop="addNewLicenceAccount"
        >
          {{$t('ok')}}
        </button> -->
      </template>
    </Modal>
  </template>
  
  <script>
  
  import Modal from '@dtplugins/modal/modal';
  import { licenceAccountsService } from '../../services/licence-accounts.service';
  
  import {
    createTV,
    tv,
  } from "../../../../models/text-value.model";
  export default {
    components: {
      Modal,
    },
    props: {
      
    },
    data: function() {
      return {
      };
    },
    mounted:async function() {
      console.log("TTTTTTTTT",this.$route)
    },
    computed: {
      licence_id: function () {
       return this.$route.params.licence_id;
      },
    },
    methods: {

      onCancel: function() {
        this.$emit("cancelled", true);
      },
       addNew: async function(e) {
        console.log(e)
        this.$router.push({
          ...this.$route,
          query: {
            modal: "add_new_asset_modal",
            payload: { licence_id:this.licence_id ,asset_type:e  }
          },
        });
        //this.$emit('addLicenceAccount', {year:this.year , keyword:this.keyword, accounting_period:this.accounting_period});
      },
      //MARK: Methods
    }
  };
  
  
  </script>
  
  <style lang="scss">
  .cmp-label-licence-select-asset {
    .dt-modal--header{
      text-align: center;
    }
    .btn-width{
      max-width: 145px;
      min-width: 145px;
      padding:0px 10px;
    }
  }
  </style>